{
    "agenda": "Agenda",
    "allDay": "Todo el día",
    "date": "Fecha",
    "day": "Día",
    "event": "Sesión",
    "month": "Mes",
    "next": "Siguiente",
    "noEventsInRange": "No hay sesiones en este rango",
    "previous": "Anterior",
    "time": "Hora",
    "today": "Hoy",
    "tomorrow": "Mañana",
    "week": "Semana",
    "workWeek": "Semana laboral",
    "yesterday": "Ayer",
    "more": "más",

    "currentMonth": "Mes actual",
    "from": "Desde",
    "lastFifteenDays": "Últimos 15 días",
    "lastSevenDays": "Últimos siete días",
    "lastThirtyDays": "Últimos 30 días",
    "lastWeek": "Semana pasada",
    "nextMonth": "Próximo mes",
    "reset": "Limpiar",
    "thisWeek": "Esta semana",
    "to": "Hasta"
}
